// ? Заказчик не согласовал виды работ, но уже реализовали, поэтому закомментирован до лучших времен
// ? Также изменена сортировка столбцов для сохранения прежнего вида

import { TTableConfig } from '../types/projects';

export const DEFAULT_TABLE_CONFIG: TTableConfig[] = [
  {
    columnTechName: 'status',
    columnExportRow: 'StatusName',
    key: 'status.name',
    columnName: 'Статус',
    isVisible: true,
    columnOrder: 1,
    meta: {
      size: 'sm',
      disabled: true,
      class: 'table-list-projects__td_status-wrap',
    },
  },
  {
    columnTechName: 'partnerCountry',
    columnExportRow: 'PartnerCountryName',
    key: 'partnerCountry.name',
    columnName: 'Страна-партнер',
    isVisible: true,
    columnOrder: 5,
    meta: {
      size: 'l',
      disabled: true,
    },
  },
  {
    columnTechName: 'name',
    columnExportRow: 'Name',
    key: 'name',
    columnName: 'Название',
    isVisible: true,
    columnOrder: 3,
    meta: {
      size: 'l',
      disabled: true,
    },
  },
  {
    columnTechName: 'fromEhd',
    columnExportRow: 'SourceName',
    key: 'fromEhd',
    columnName: 'Источник',
    isVisible: true,
    columnOrder: 2,
    meta: {
      size: 'm',
      disabled: false,
    },
  },
  {
    columnTechName: 'projectPurpose',
    columnExportRow: 'Purposes',
    key: 'purposeNames',
    columnName: 'Цель проекта',
    isVisible: true,
    columnOrder: 6,
    meta: {
      size: 'l',
      disabled: false,
    },
  },
  {
    columnTechName: 'projectCountries',
    columnExportRow: 'ProjectCountries',
    key: 'country.name',
    columnName: 'Страны реализации инвестиционного проекта',
    isVisible: true,
    columnOrder: 4,
    meta: {
      size: 'l',
      disabled: false,
    },
  },
  // {
  //   columnTechName: 'initiator',
  //   columnExportRow: 'Initiator',
  //   key: 'initiator',
  //   columnName: 'Организация, реализующая проект',
  //   isVisible: true,
  //   columnOrder: 7,
  //   meta: {
  //     size: 'l',
  //     disabled: false,
  //   },
  // },
  {
    columnTechName: 'plannedYearStartInvStage',
    columnExportRow: 'PlannedYearStartInvStage',
    key: 'plannedYearStartInvStage',
    columnName: 'Плановый год начала реализации инвестиционной стадии проекта',
    isVisible: true,
    columnOrder: 7,
    meta: {
      size: 'm',
      disabled: false,
      sort: {
        columnIndex: 0,
      },
    },
  },
  {
    columnTechName: 'plannedYearEndInvStage',
    columnExportRow: 'PlannedYearEndInvStage',
    key: 'plannedYearEndInvStage',
    columnName: 'Плановый год окончания реализации инвестиционной стадии проекта',
    isVisible: true,
    columnOrder: 8,
    meta: {
      size: 'm',
      disabled: false,
      sort: {
        columnIndex: 1,
      },
    },
  },
  {
    columnTechName: 'totalInvestmentMlrdRub',
    columnExportRow: 'TotalInvestmentMlrdRub',
    key: 'totalInvestmentMlrdRub',
    columnName: 'Общий объем инвестиций, млрд руб.',
    isVisible: true,
    columnOrder: 9,
    meta: {
      size: 'l',
      disabled: false,
      sort: {
        columnIndex: 2,
      },
      type: 'number',
    },
  },
  {
    columnTechName: 'totalInvestmentThousDol',
    columnExportRow: 'TotalInvestmentThousDolText',
    key: 'totalInvestmentThousDol',
    columnName: 'Общий объем инвестиций, тыс. долларов',
    isVisible: true,
    columnOrder: 10,
    meta: {
      size: 'l',
      disabled: false,
      type: 'number',
    },
  },
  {
    columnTechName: 'industry',
    columnExportRow: 'IndustryName',
    key: 'industry.name',
    columnName: 'Отрасль',
    isVisible: true,
    columnOrder: 11,
    meta: {
      size: 'm',
      disabled: false,
    },
  },
  {
    columnTechName: 'description',
    columnExportRow: 'Description',
    key: 'description',
    columnName: 'Описание',
    isVisible: true,
    columnOrder: 12,
    meta: {
      size: 'l',
      disabled: false,
    },
  },
  // {
  //   columnTechName: 'mpkComissionName',
  //   columnExportRow: 'MpkComissionName',
  //   key: 'mpkComissionName',
  //   columnName: 'МПК',
  //   isVisible: true,
  //   columnOrder: 14,
  //   meta: {
  //     size: 'l',
  //     disabled: false,
  //   },
  // },
  {
    columnTechName: 'projectList',
    columnExportRow: 'ProjectListName',
    key: 'projectList.name',
    columnName: 'Перечень проекта',
    isVisible: true,
    columnOrder: 13,
    meta: {
      size: 'l',
      disabled: false,
    },
  },
  // {
  //   columnTechName: 'foivCurator',
  //   columnExportRow: 'FoivCuratorName',
  //   key: 'foivCurator.name',
  //   columnName: 'ФОИВ-куратор',
  //   isVisible: true,
  //   columnOrder: 16,
  //   meta: {
  //     size: 'l',
  //     disabled: false,
  //   },
  // },
  // {
  //   columnTechName: 'constantNewJobs',
  //   columnExportRow: 'ConstantNewJobs',
  //   key: 'constantNewJobs',
  //   columnName: 'Постоянные новые рабочие места, чел.',
  //   isVisible: true,
  //   columnOrder: 17,
  //   meta: {
  //     size: 'l',
  //     disabled: false,
  //   },
  // },
  // {
  //   columnTechName: 'regionOfChina',
  //   columnExportRow: 'RegionOfChina',
  //   key: 'regionOfChina',
  //   columnName: 'Регион реализации проекта в КНР',
  //   isVisible: true,
  //   columnOrder: 18,
  //   meta: {
  //     size: 'l',
  //     disabled: false,
  //   },
  // },
  // {
  //   columnTechName: 'regionOfRussia',
  //   columnExportRow: 'RegionOfRussia',
  //   key: 'regionOfRussia',
  //   columnName: 'Регион реализации проекта в РФ',
  //   isVisible: true,
  //   columnOrder: 19,
  //   meta: {
  //     size: 'l',
  //     disabled: false,
  //   },
  // },
  // {
  //   columnTechName: 'problems',
  //   columnExportRow: 'Problem',
  //   key: 'problems',
  //   columnName: 'Проблема',
  //   isVisible: true,
  //   columnOrder: 20,
  //   meta: {
  //     size: 'xl',
  //     disabled: false,
  //   },
  // },
];
